import { createContext, useContext, ReactNode } from "react";
import { useGetSession, AuthUser } from "@workspace/api-client-react";

type AuthContextType = {
  user: AuthUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
};

const AuthContext = createContext<AuthContextType>({
  user: null,
  isLoading: true,
  isAuthenticated: false,
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const sessionQuery = useGetSession({
    query: {
      retry: false,
    },
  });
  const { data: user, isPending, isFetching } = sessionQuery;

  return (
    <AuthContext.Provider
      value={{
        user: user || null,
        isLoading: isPending || (isFetching && !user),
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
